/**
 * Campi API con naming misto camelCase / PascalCase / snake_case.
 * @param {Record<string, unknown>} row
 * @param {...string} keys
 * @returns {unknown}
 */
export function pickApiField(row, ...keys) {
  for (const k of keys) {
    if (Object.prototype.hasOwnProperty.call(row, k) && row[k] !== undefined && row[k] !== null && row[k] !== '') {
      return row[k]
    }
  }
  return undefined
}

/**
 * @param {unknown} item
 * @returns {number | null}
 */
export function pickOrganizationIdFromConfigItem(item) {
  if (!item || typeof item !== 'object') return null
  const record = /** @type {Record<string, unknown>} */ (item)
  const raw = pickApiField(record, 'organizationId', 'OrganizationId', 'organization_id')
  if (raw == null) return null
  const n = Number(raw)
  return Number.isFinite(n) ? n : null
}
